import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LicensingAuthService } from '../services/licensing-auth.service';

/**
 * Login Component.
 * Acts as the entry point for unauthenticated users in standalone mode.
 *
 * If the user already has an established DTIMS session the component redirects
 * immediately to the app root. Otherwise it delegates to LicensingAuthService
 * to redirect the browser to the backend authentication page, where the user
 * selects their tenant and environment before being sent to Okta for login.
 */
@Component({
  selector: 'd-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent implements OnInit {
  /** Auth service for session check and login redirect. */
  private readonly authService: LicensingAuthService = inject(LicensingAuthService);

  /** Angular router for client-side navigation. */
  private readonly router: Router = inject(Router);

  /** Redirects to home if already authenticated, otherwise initiates the backend auth flow. */
  public ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      void this.router.navigate(['/']);
    } else {
      this.authService.redirectToLogin();
    }
  }
}
